import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Package, ArrowRight, ChatCircleText } from '@phosphor-icons/react';
import API from '../lib/api';
import { useUnread } from '../lib/unread';

const STATUS_LABELS = {
  pending_payment: 'Payment pending',
  pending_partner: 'Finding partner',
  unassigned: 'Waiting for partner',
  accepted: 'Accepted',
  printing: 'Printing',
  printed: 'Printed',
  out_for_delivery: 'Out for delivery',
  delivered: 'Delivered',
};

const CustomerOrders = () => {
  const [orders, setOrders] = useState([]);
  const { counts: unread } = useUnread();

  useEffect(() => {
    API.get('/orders').then(r => setOrders(r.data)).catch(() => {});
  }, []);

  return (
    <div className="p-6">
      <div className="reg-mark">
        <div className="text-[10px] tracking-[0.32em] uppercase font-bold" style={{ color: 'var(--pk-primary)' }}>— My orders</div>
        <h1 className="font-display text-[28px] mt-2 leading-tight">Your print jobs.</h1>
      </div>
      <div className="mt-5 space-y-3">
        {orders.length === 0 && <div className="pk-card p-6 text-center text-[13px] text-neutral-500"><Package size={26} className="mx-auto mb-2"/> No orders yet.</div>}
        {orders.map((o) => {
          const count = unread[o.order_id] || 0;
          const hasUnread = count > 0;
          return (
            <Link
              key={o.order_id}
              to={`/orders/${o.order_id}`}
              className={`pk-card p-4 block relative ${hasUnread ? 'brutal-shadow-magenta' : ''}`}
              style={hasUnread ? { borderColor: 'var(--pk-primary)' } : {}}
              data-testid={`order-row-${o.order_id}`}
            >
              {hasUnread && (
                <>
                  {/* Corner flag ribbon */}
                  <span
                    className="absolute -top-[2px] -left-[2px] flex items-center gap-1 px-2 py-0.5 border-2 border-black text-white text-[9px] tracking-[0.18em] uppercase font-bold"
                    style={{ background: 'var(--pk-primary)' }}
                    data-testid={`order-unread-flag-${o.order_id}`}
                  >
                    <ChatCircleText size={11} weight="fill" />
                    New msg
                  </span>
                  {/* Right-side count badge */}
                  <span
                    className="absolute top-2 right-2 min-w-[22px] h-5 px-1.5 border-2 border-black text-white text-[10px] font-bold flex items-center justify-center font-mono"
                    style={{ background: 'var(--pk-primary)' }}
                    data-testid={`order-unread-count-${o.order_id}`}
                  >
                    {count}
                  </span>
                </>
              )}
              <div className={`flex items-center justify-between ${hasUnread ? 'mt-3' : ''}`}>
                <div className={`font-mono text-[10px] tracking-[0.2em] uppercase ${hasUnread ? 'text-black font-bold' : 'text-neutral-500'}`}>#{o.order_id.slice(-8)}</div>
                <div className={`text-[10px] font-mono ${hasUnread ? 'text-black font-bold' : 'text-neutral-500'}`}>{o.created_at?.slice(0,10)}</div>
              </div>
              <div className={`mt-2 leading-tight ${hasUnread ? 'font-extrabold text-[15px]' : 'font-bold text-[14px]'}`}>
                {o.items.map(i => `${i.quantity}× ${i.product_name}`).join(', ')}
              </div>
              <div className="mt-3 flex items-center justify-between gap-2">
                <div className={`status-${o.status} border-2 border-black text-[9px] tracking-[0.18em] font-bold uppercase px-2 py-1`}>{STATUS_LABELS[o.status] || o.status}</div>
                <div className={`font-mono ${hasUnread ? 'font-extrabold' : 'font-bold'}`}>₹{(o.total_amount || 0).toLocaleString('en-IN')}</div>
                <ArrowRight size={14} weight="bold" />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CustomerOrders;
